import React from 'react';
import {injectIntl} from 'react-intl';
import Breadcrumbs from '@Components/Breadcrumbs';

const PageHeader = ({title, subtitle}) => {
  return (
    <>
      <div className="header header--text bg-brand--dark-blue">
        <div className="wrapper">
          <Breadcrumbs jobSearchUrl='/'/>
          <div className="header__content header__content--full-width content-block">
            {title && <h1 className="content-block__title">{title}</h1>}
            {subtitle && <p className="content-block__description l:w-1/2">{subtitle}</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(PageHeader);
